// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getHasSample, { HasSampleModelParameter } from "@store/Framework/Common/Utilities/samples/getHasSample";
import { getIsB2BCustomer } from "@store/Framework/Store/Data/BillTos/BillTosSelectors";

const getShowInventory = (state: ApplicationState, hasSampleModel?: HasSampleModelParameter) => {
    return getIsB2BCustomer(state) && state.context.showInventory;
};

export default getShowInventory;
